import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as cmAPI from 'actions/commons';

import { Form, Button } from 'semantic-ui-react';

class DateType extends Component {
  constructor(props) {
    super(props);
    const { defaultType } = this.props;
    this.state = {
      type: defaultType || 'MM'
    };
  }

  componentWillMount() {
    const { type } = this.state;
    this.handleChange(type);
  }

  changeType = async (e, { value }) => {
    e.preventDefault();
    await this.setState({ type: value });

    this.handleChange(value);
  };

  handleChange = (value) => {
    const { commonFn } = this.props;
    commonFn.changeType({
      type: 'dateType',
      name: 'value',
      value: value
    });
  };

  render() {
    const { isSum } = this.props;
    const { type } = this.state,
      dataTypes = {
        month: 'MM',
        day: 'DD',
        sum: 'SUM'
      };

    return (
      <Form.Field inline>
        <Button.Group basic className="month-btn">
          {isSum ? (
            <Button value={dataTypes.sum} className={type === dataTypes.sum ? 'active' : ''} onClick={this.changeType}>
              합계
            </Button>
          ) : null}
          <Button
            value={dataTypes.month}
            className={type === dataTypes.month ? 'active' : ''}
            onClick={this.changeType}
          >
            월별통계
          </Button>
          <Button value={dataTypes.day} className={type === dataTypes.day ? 'active' : ''} onClick={this.changeType}>
            일별통계
          </Button>
        </Button.Group>
      </Form.Field>
    );
  }
}

DateType = connect(
  (state) => ({
    dateType: state.commons.dateType
  }),
  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changeType: cmAPI.ReduxDataSet
      },
      dispatch
    )
  })
)(DateType);

export default DateType;
